import { APPLICATION_COMPLETE, CONSENT_ADVERTISING, CONSENT_ANALYTICS, eventName as resolveEventName } from "../events";
import { injectScript } from "./script";

/**
 * Google: GA4 (eventos, consentimento analytics) e Google Ads (conversão, consentimento advertising).
 * Reaproveita o window.gtag carregado pelo vue-gtag (plugins/ga.js) quando existir.
 */
function ensureGtag(id) {
    if (typeof window.gtag === "function") {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());

    injectScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`);
}

function analyticsAllowed(config, allowed) {
    return !!config.analytics_id && allowed(CONSENT_ANALYTICS);
}

function adsAllowed(config, allowed) {
    return !!config.ads_id && allowed(CONSENT_ADVERTISING);
}

export default {
    name: "google",

    isAllowed(config, allowed) {
        return !!config && (analyticsAllowed(config, allowed) || adsAllowed(config, allowed));
    },

    init(config, allowed) {
        if (analyticsAllowed(config, allowed)) {
            ensureGtag(config.analytics_id);
            // page_view já é enviado pelo vue-gtag; aqui só habilita o send_to dos eventos
            window.gtag("config", config.analytics_id, { send_page_view: false });
        }

        if (adsAllowed(config, allowed)) {
            ensureGtag(config.ads_id);
            window.gtag("config", config.ads_id);
        }
    },

    send(eventName, payload, config, allowed) {
        const nativeName = resolveEventName("google", config, eventName);
        if (!nativeName || typeof window.gtag !== "function") {
            return;
        }

        if (analyticsAllowed(config, allowed)) {
            window.gtag("event", nativeName, {
                send_to: config.analytics_id,
                event_id: payload.event_id,
                portal_id: payload.portal_id,
                campaign_source: payload.source,
                campaign_medium: payload.medium,
                campaign_name: payload.campaign,
                items: payload.job_id ? [{ item_id: String(payload.job_id), item_name: payload.job_title }] : undefined,
            });
        }

        // Conversão do Google Ads: rótulo por evento (ads_labels) ou, por compatibilidade, o rótulo principal
        // na candidatura concluída. Evento sem rótulo não gera conversão.
        const adsLabel = (config.ads_labels && config.ads_labels[eventName])
            || (eventName === APPLICATION_COMPLETE ? config.ads_conversion_label : null);

        if (adsLabel && adsAllowed(config, allowed)) {
            window.gtag("event", "conversion", {
                send_to: `${config.ads_id}/${adsLabel}`,
                transaction_id: payload.event_id,
            });
        }
    },
};
